<template>
    <div class="login">
      <div class="head">
        <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
        <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
        <router-link class="reg" tag="div" to="/reg" v-if="Tversion != 1">{{$t('lg.register')}}</router-link>
      </div>
      <div class="cotainer">
        <div class="img-box"><img class="logo" :src="'/static/logo/logo2-v'+Tversion+'.png'"></div>
        <!-- <div class="h4">Gold payer</div> -->
          <h1 class="h1">{{$t('lg.welcome')}}</h1>
          <template v-if="Tversion != 1">
            <div class="tips">{{$t('xgdlmm.zh')}}</div>
            <div class="temp1Inputb inputb">
              <input class="text1" type="text" @blur="hideBorder" @focus="showBorder" v-model="userName" :placeholder="$t('langNew4.qsrndzh')">
              <img v-if="!theme" v-show="userName" src="@/assets/Log-In_delete.png" class='text2 icon' @click="clear" />
              <img v-else v-show="userName" src="@/assets/theme/close2.png" class='text2 icon' @click="clear" />
            </div>
            <div class="tips">{{$t('xgdlmm.mm')}}</div>
            <div class="temp1Inputb inputb">
              <input class="text1" ref="input" @blur="hideBorder1" @focus="showBorder1" v-model="passwords" type="password" :placeholder="$t('lg.ppwd')">
              <template v-if="isPwd">
                <img v-if="!theme" v-show="passwords" src="@/assets/Log-In_close-eyes.png" class='text2 icon' @click="shpass" />
                <img v-else v-show="passwords" src="@/assets/theme/eyes.png" class='text2 icon' @click="shpass" />
              </template>
               <template v-else>
                <img v-if="!theme" v-show="passwords" src="@/assets/Log-In_eyes.png" class='text2 icon' @click="shpass" />
                <img v-else v-show="passwords" src="@/assets/theme/eyes2.png" class='text2 icon' @click="shpass" />
              </template>
            </div>
            <button class="btn-login btn-bg buttbg" @click="login">{{$t('lg.lgs')}}</button>
          </template>

          <button class="btn-qbdl btn-bg" @click="loginWallet">{{$t('lg.qbdl')}}</button>
          <ul class="item-box" v-if="Tversion != 1">
            <li class="text t2" v-show="temp_user" @click="create">{{$t('tipsNew.cjxnzh')}}</li>
            <router-link tag="li" class="text" to="/forgetPwd">{{$t('lg.ftpwd')}}</router-link>
            <!-- <router-link tag="li" class="text" to="/language">{{$t('lg.language')}}</router-link> -->
          </ul>
      </div>

      <div class="mask" v-if="shownotice">
        <div class="dialog1">
          <div class="titleb">
            <span class="text2"></span>
            <span class="text1">{{$t("提示")}}</span>
            <img src="@/assets/new/close.png" class="img1" @click="shownotice=false" />
          </div>
          <div class="line2">{{$t("请用钱包APP访问")}}</div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'login',
    components:{
    },
    data () {
        return {
            theme: false,
            isPwd: true,
            userName: '',
            passwords: '',
            temp_user: false,
            index: 0,
            borderLine:false,
            borderLine1:false,
            shownotice:false,
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      localStorage.removeItem('regCheck');
      this.getCheckcode();
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
      this.userName = localStorage.getItem('account') || '';
      this.passwords = localStorage.getItem('pwd') || '';
    },
    methods: {
      back(){
        this.$router.push('/index')
      },
      showBorder(){
        this.borderLine = true
      },
      hideBorder(){
        this.borderLine = false
      },
      showBorder1(){
        this.borderLine1 = true
      },
      hideBorder1(){
        this.borderLine1 = false
      },
      getCheckcode(){
        let params = {
            token: 1
        }
        this.$ajax.get('/web/reg_checkcode',{params}).then((res) => {
            let resData = res.data.data;
            this.temp_user = resData.temp_user;
        }).catch(function(err){
            console.log(err)
        })
      },
      create(){
        let params = {
              token:1,
          }
          this.$ajax.get('/web/tempLogin',{params}).then((res) => {
            let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                 localStorage.setItem('isMn',true);
                  this.saveData(resData);
                  setTimeout(() => {
                    this.$router.push('/index')
                  }, 1000)
              }else{
                  this.$toast.center(resData.message);
                  return;
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      clear(){
        this.userName = ''
      },
      // 密码显示或者隐藏
      shpass() {
        if(this.isPwd){
          this.isPwd = false;
          this.$refs.input.type = "text";
        }else{
          this.isPwd = true;
          this.$refs.input.type = "password";
        }
      },
      loginWallet(){
        if(!window.ethereum){
          // console.log('wallet null');
          this.shownotice = true;
          window.location.href = `trust://open_url?url=${document.URL}`;
        }else{
          this.getAddress();
        }
      },
       login(){
        if(!this.userName) {
            this.$toast.center(this.$t('langNew4.qsrndzh'));
            return false;
        }
        if(!this.passwords) {
            this.$toast.center(this.$t('lg.ppwd'));
            return false;
        }
        if(this.userName.indexOf('@') > 0){
            this.index = 1
        }else{
            this.index = 0
        }
        let params = {
            account: this.userName,
            password: this.passwords,
            index: this.index,
            sms_code: '',
            token: 1
        }
        this.$ajax.post('/web/userLogin',params).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0 || res.data.code == 4 || res.data.code == 7){
            localStorage.setItem('isMn',false);
            this.saveData(resData);
            setTimeout(() => {
              this.$router.push('/index')
            }, 1000)
          }else{
              this.$toast.center(res.data.message);
              return;
          }
        }).catch(function(err){
            console.log(err)
        })
       },

       async getAddress() {
           var that = this;
           let web3Provider = null;
           if (window.ethereum) {
             web3Provider = window.ethereum;
             try {
               await window.ethereum.request({ method: "eth_requestAccounts" });
             } catch (error) {
               console.error("User denied account access");
               return false;
             }
           } else if (window.web3) {
             web3Provider = window.web3.currentProvider;
           } else {
             web3Provider = new Web3.providers.HttpProvider(that.adsHOST);
           }
           if (web3Provider) {
             const Web3address = new Web3(web3Provider);
             try {
               const accounts = await Web3address.eth.getAccounts();
               const address = accounts[0];
               if (address) {
                 that.address = address;
                 that.getEthLogin();
               } else {
                 that.$toast.center('Failed to connect to address');
               }
             } catch (error) {
               that.$toast.center('Failed to connect to address');
             }
           } else {
             that.$toast.center('Failed to connect to address');
           }
       },
       getEthLogin(){
         let params = {
             address: this.address,
             // address: '0xCA62b5Cb65D4dad8AeEea158cB72a4257Fc25E24'
         }
         this.$ajax.get('/web/ethLogin',{params}).then((res) => {
           let resData = res.data.data;
           if(res.data.code == 0){
             this.saveData(resData);
             this.$router.push('/index');
           }else{
             this.$toast.center(res.data.message);
           }
         }).catch(function(err){
             console.log(err)
         })
       },

       saveData(res){
         localStorage.setItem('token',res.token);
         localStorage.setItem('uid',res.id);
         localStorage.setItem('agentId',res.agent_id);
         localStorage.setItem('invitation_code',res.invitation_code);
         localStorage.setItem('link',res.link);
         localStorage.setItem('userName',res.name);
         if(this.userName && this.passwords){
           localStorage.setItem('account',this.userName);
           localStorage.setItem('pwd',this.passwords);
         }else{
           localStorage.setItem('account',res.name);
         }
       },

    },
    beforeDestroy(){

    }
}
</script>
<style scoped lang="less">
    .head{
        position: relative;
        height: 1.6rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
    }
    .head .back{
        position: absolute;
        left: .6rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .reg{
      position: absolute;
      right: .6rem;
      top: 50%;
      color: #000;
      font-size: .48rem;
      transform: translateY(-50%);
    }
    .cotainer{
      padding: 15px;
      background: #fff;
    }
    .cotainer .img-box{
      margin: .5rem auto .2rem;
      text-align: center;
    }
    .cotainer .img-box .logo{
      width: 2.18rem;
    }
    .cotainer .h4{
      color: #fff;
      font-size: .52rem;
      text-align: center;
    }
    .cotainer .h1{
        padding: .4rem 0 .5rem;
        color: #000;
        font-size: .7rem;
        text-align: center;
    }
    .cotainer .h3{
        color: #9f9f9f;
        font-size: .4rem;
    }
    .cotainer .tips{
      padding-bottom: 0.15rem;
      color: #000;
      font-size: .4rem;
    }
    .cotainer .input-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .4rem .72rem;
      background: #fff;
      border-radius: .3rem;
      border: solid 1px #d5d5d5;
    }
    .cotainer .active {
      border: solid 3px #000 !important;
    }
    .cotainer .active1 {
      border: solid 3px #000 !important;
    }
    .cotainer .input-box .icon{
      width: .6rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #999;
        font-size: .46rem;
    }
    .cotainer .input-pwd{
        /* margin-top: 1.3rem; */
    }
    .cotainer .input-box .input{
        width: 100%;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: .66rem 0;
        font-size: .46rem;
    }
    .cotainer .btn-login{
        display: block;
        width: 100%;
        margin-top: .88rem;
    }
    .cotainer .btn-qbdl{
      background: #fff !important;
      border: solid 1px #d5d5d5 !important;
      color: #000;
      display: block;
      width: 100%;
      margin-top: .4rem;
    }
    .cotainer .t1{
      padding: 1.9rem 0 .4rem;
      color: #acacac;
      font-size: .4rem;
    }
    .cotainer .t2{
      margin-right: .2rem;
      color: #588bf8;
    }
    .cotainer .inputb .icon{width: 0.7rem;}

    .dialog1{width: 300px;margin: 25% auto;padding: 15px;background-color: #fff;border-radius: 15px;}
    .dialog1 .titleb{display: flex;justify-content: space-between;align-content: center;}
    .dialog1 .titleb .text1{font-size: 16px;}
    .dialog1 .titleb .text2{width: 20px;}
    .dialog1 .titleb .img1{width: 25px;position: relative;top: -5px;}
    .dialog1 .line2{padding: 20px 0 50px;font-size: 16px;text-align: center;}


  /* @media screen and (min-width:800px) {
    .login{}
    .head{height: 0;overflow: hidden;}
    .cotainer{width: 350px;margin: 5% auto;box-shadow: 0 0 8px 1px #00000055;border-radius: 5px;
      padding: 15px 30px;}
  } */

</style>
<style type="text/css">
  @media screen and (min-width:800px) {
    html{font-size: 28px;}
  }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue